import StarIcon from '../icons/StarIcon';

export function MarqueeRow({ text, reverse = false }: { text: string; reverse?: boolean }) {
  const marqueeAttr = reverse ? 'reverse' : 'true';
  const items = Array.from({ length: 7 });

  return (
    <div className="marquee_wrapper">
      {[0, 1].map((dupIdx) => (
        <div key={dupIdx} marquee={marqueeAttr} className="marquee_inner scroll">
          {items.map((_, itemIndex) => (
            <span key={itemIndex} style={{ display: 'contents' }}>
              <h2 className="display_xl-class">{text}</h2>
              <StarIcon size={56} spinning />
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}

export default function PressSection() {
  return (
    <section className="home_press" aria-labelledby="press-section-title">
      <div className="container press-feature-shell">
        <header className="press-feature-header">
          <h2 id="press-section-title">Real stories. Clearer thinking.</h2>
          <span>
            Candid conversations about money, ambition and the decisions that shape a life.
          </span>
        </header>

        <div stagger-fade="trigger" className="press-banner">
          <img
            loading="lazy"
            alt="Podcast conversation – candid stories about money, ambition and life"
            src="/imgs/podcast.png"
          />
        </div>
      </div>
    </section>
  );
}
